<template>
  <div class="insurance-table-plan-container">
    <div class="insurance-table-plan-header-section">
      <div class="insurance-table-plan-header">ตารางผลประโยชน์และเบี้ยประกันภัย</div>
      <div class="insurance-table-plan-header">กรมธรรม์ประกันภัยสุขภาพและอุบัติเหตุส่วนบุคคล</div>
    </div>
    <div class="total-plan-section">
      <div class="total-plan-header">จำนวนเงินเอาประกันภัย</div>
      <div class="total-plan-amount-section" :class="{ 'with-extra': isShowExtra }">
        <div
          class="total-plan-amount"
          v-for="plan in _.get(insurancePlanInformationData, 'coveragePlanInfo.plans', [])"
          :key="plan.planId"
        >
          <div class="plan-name">
            {{ plan.planName }}
          </div>
          <div class="plan-description">(เบี้ยสุทธิรวมอากร 0.4%ก่อนหักส่วนลด)</div>
          <div class="plan-amount">
            {{ plan.premium | formatNumber }}
          </div>
        </div>
      </div>
    </div>
    <div class="protection-benefit-section">
      <div class="protection-benefit-header">ความคุ้มครอง</div>
      <div class="protection-information-section">
        <div class="radio-package-plan-container" :class="{ 'with-extra': isShowExtra }">
          <div
            class="radio-package-plan"
            v-for="plan in _.get(insurancePlanInformationData, 'coveragePlanInfo.plans', [])"
            :key="`radio-${plan.schemeId}`"
          >
            <Radio
              name="insurancePlan"
              :label="plan.planId"
              v-model="insurancePlan.planType"
              :disabled="disabledForm"
            />
          </div>
        </div>

        <!-- IPD -->
        <div class="ipd-protection-benefit-section">
          <div class="benefit-header-section">
            <div class="package-name">
              <Checkbox
                :isCheck="insurancePlan.isCheckIPD"
                :onCheck="$evt => onCheckInsurancePlan($evt, 'isCheckIPD')"
                optionText="IPD"
                disabled
              />
            </div>
            <div class="package-description">
              ข้อตกลงคุ้มครองการอยู่รักษาตัวในโรงพยาบาลหรือสถานเวชกรรม (ผู้ป่วยใน IPD)
            </div>
          </div>
          <div class="benefit-body-section">
            <div
              class="content-section"
              :class="{ 'main-content': checkIsMainContent(data.sumInsured) }"
              v-for="data in _.get(insurancePlanInformationData, 'packageInfo.IPD', [])"
              :key="`IPD#${data.index}`"
            >
              <div class="benefit-description">
                <span v-if="data.coverageNameTh">{{ data.coverageNameTh }} </span>
                <span v-if="data.coverageNameEn">{{ data.coverageNameEn }} </span>
                <span v-if="data.coverageConditionTh">{{ data.coverageConditionTh }} </span>
                <span v-if="data.coverageConditionEn">{{ data.coverageConditionEn }} </span>
              </div>
              <div
                class="benefit-value-section"
                :class="{ 'with-extra': isShowExtra }"
                v-if="!checkIsMainContent(data.sumInsured)"
              >
                <div
                  class="benefit-value"
                  v-for="(sumInsured, keyName) in data.sumInsured"
                  :key="`IPD-${keyName}`"
                >
                  {{ sumInsured }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- OPD -->
        <div class="opd-protection-benefit-section">
          <div class="benefit-header-section">
            <div class="package-name">
              <Checkbox
                :isCheck="insurancePlan.isCheckOPD"
                :onCheck="$evt => onCheckInsurancePlan($evt, 'isCheckOPD')"
                optionText="OPD"
                :disabled="disabledForm"
              />
            </div>
            <div class="package-description">
              ข้อตกลงคุ้มครองการรักษาพยาบาลที่ไม่ได้อยู่รักษาตัวในโรงพยาบาลหรือสถานเวชกรรม
              (ผู้ป่วยนอก OPD)
            </div>
          </div>
          <div class="benefit-body-section">
            <div
              class="content-section"
              :class="{ 'main-content': checkIsMainContent(data.sumInsured) }"
              v-for="data in _.get(insurancePlanInformationData, 'packageInfo.OPD', [])"
              :key="`OPD#${data.index}`"
            >
              <div class="benefit-description">
                <Radio
                  name="opdType"
                  :label="data.value"
                  v-model="insurancePlan.opdType"
                  :disabled="disabledForm"
                >
                  <span v-if="data.coverageNameTh">{{ data.coverageNameTh }} </span>
                  <span v-if="data.coverageNameEn">{{ data.coverageNameEn }} </span>
                  <span v-if="data.coverageConditionTh">{{ data.coverageConditionTh }} </span>
                  <span v-if="data.coverageConditionEn">{{ data.coverageConditionEn }} </span>
                </Radio>
              </div>
              <div
                class="benefit-value-section"
                :class="{ 'with-extra': isShowExtra }"
                v-if="!checkIsMainContent(data.sumInsured)"
              >
                <div
                  class="benefit-value"
                  v-for="(sumInsured, keyName) in data.sumInsured"
                  :key="`IPD-${keyName}`"
                >
                  {{ sumInsured }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- HIB -->
        <div class="hib-protection-benefit-section">
          <div class="benefit-header-section">
            <div class="package-name">
              <Checkbox
                :isCheck="insurancePlan.isCheckHIB"
                :onCheck="$evt => onCheckInsurancePlan($evt, 'isCheckHIB')"
                optionText="HIB"
                :disabled="disabledForm"
              />
            </div>
            <div class="package-description">
              เงินชดเชยรายได้รายวันระหว่างรักษาตัวในโรงพยาบาล (HIB)
            </div>
          </div>
          <div class="benefit-body-section">
            <div
              class="content-section"
              :class="{ 'main-content': checkIsMainContent(data.sumInsured) }"
              v-for="data in _.get(insurancePlanInformationData, 'packageInfo.HIB', [])"
              :key="`HIB#${data.index}`"
            >
              <div class="benefit-description">
                <span v-if="data.coverageNameTh">{{ data.coverageNameTh }} </span>
                <span v-if="data.coverageNameEn">{{ data.coverageNameEn }} </span>
                <span v-if="data.coverageConditionTh">{{ data.coverageConditionTh }} </span>
                <span v-if="data.coverageConditionEn">{{ data.coverageConditionEn }} </span>
              </div>
              <div
                class="benefit-value-section"
                :class="{ 'with-extra': isShowExtra }"
                v-if="!checkIsMainContent(data.sumInsured)"
              >
                <div
                  class="benefit-value"
                  v-for="(sumInsured, keyName) in data.sumInsured"
                  :key="`IPD-${keyName}`"
                >
                  {{ sumInsured }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- CANCER -->
        <div class="cancer-protection-benefit-section">
          <div class="benefit-header-section">
            <div class="package-name">
              <Checkbox
                :isCheck="insurancePlan.isCheckCancer"
                :onCheck="$evt => onCheckInsurancePlan($evt, 'isCheckCancer')"
                optionText="Cancer"
                :disabled="disabledForm"
              />
            </div>
            <div class="package-description">
              การประกันภัยโรคมะเร็ง (CANCER)
            </div>
          </div>
          <div class="benefit-body-section">
            <div
              class="content-section"
              :class="{ 'main-content': checkIsMainContent(data.sumInsured) }"
              v-for="data in _.get(insurancePlanInformationData, 'packageInfo.CANCER', [])"
              :key="`CANCER#${data.index}`"
            >
              <div class="benefit-description">
                <span v-if="data.coverageNameTh">{{ data.coverageNameTh }} </span>
                <span v-if="data.coverageNameEn">{{ data.coverageNameEn }} </span>
                <span v-if="data.coverageConditionTh">{{ data.coverageConditionTh }} </span>
                <span v-if="data.coverageConditionEn">{{ data.coverageConditionEn }} </span>
              </div>
              <div
                class="benefit-value-section"
                :class="{ 'with-extra': isShowExtra }"
                v-if="!checkIsMainContent(data.sumInsured)"
              >
                <div
                  class="benefit-value"
                  v-for="(sumInsured, keyName) in data.sumInsured"
                  :key="`IPD-${keyName}`"
                >
                  {{ sumInsured }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Critical Illness -->
        <div class="ci-protection-benefit-section">
          <div class="benefit-header-section">
            <div class="package-name">
              <Checkbox
                :isCheck="insurancePlan.isCheckCI"
                :onCheck="$evt => onCheckInsurancePlan($evt, 'isCheckCI')"
                optionText="Clitical illness"
                :disabled="disabledForm"
              />
            </div>
            <div class="package-description">
              การประกันภัยโรคร้ายแรง (CI)
            </div>
          </div>
          <div class="benefit-body-section">
            <div
              class="content-section"
              :class="{ 'main-content': checkIsMainContent(data.sumInsured) }"
              v-for="data in _.get(
                insurancePlanInformationData,
                'packageInfo[CRITICAL ILLNESS]',
                [],
              )"
              :key="`CI#${data.index}`"
            >
              <div class="benefit-description">
                <span v-if="data.coverageNameTh">{{ data.coverageNameTh }} </span>
                <span v-if="data.coverageNameEn">{{ data.coverageNameEn }} </span>
                <span v-if="data.coverageConditionTh">{{ data.coverageConditionTh }} </span>
                <span v-if="data.coverageConditionEn">{{ data.coverageConditionEn }} </span>
              </div>
              <div
                class="benefit-value-section"
                :class="{ 'with-extra': isShowExtra }"
                v-if="!checkIsMainContent(data.sumInsured)"
              >
                <div
                  class="benefit-value"
                  v-for="(sumInsured, keyName) in data.sumInsured"
                  :key="`IPD-${keyName}`"
                >
                  {{ sumInsured }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="discount-information-container">
      <div class="protection-rules">
        <div class="information-header">
          เงื่อนไขการเลือกซื้อความคุ้มครอง
        </div>
        <div class="sub-content">
          ความคุ้มครองพื้นฐานตั้งต้นคือ ความคุ้มครองการรักษาตัวเป็นผู้ป่วยในและการประกันอุบัติเหตุ
        </div>
        <div class="sub-content">
          การซื้อความคุ้มครอง OPD, HIB, CI และ Cancer จะต้องซื้อ IPD ก่อนเสมอ
        </div>
      </div>
      <div class="family-discount-rules">
        <div class="information-header">
          เงื่อนไขการได้รับส่วนลดเบี้ยประกันภัย
        </div>
        <div class="information-header">
          1. ส่วนลดเบี้ยประกันภัยสำหรับครอบครัว 5%
        </div>
        <div class="sub-content">คู่สมรส หรือ คู่ชีวิต ทำพร้อมกัน</div>
        <div class="sub-content">บิดา หรือ มารดา ทำพร้อมบุตรอายุเกิน 16 ปี 1 คน</div>
        <div class="sub-content">บิดา หรือ มารดา ทำพร้อมบุตรอายุต่ำกว่า 16 ปี 1-2 คน</div>
      </div>
      <div class="family-discount-rules">
        <div class="information-header">
          เงื่อนไขการได้รับส่วนลดเบี้ยประกันภัย
        </div>
        <div class="information-header">
          2. ส่วนลดเบี้ยประกันภัยสำหรับครอบครัว 10%
        </div>
        <div class="sub-content">บิดา และ มารดา ทำพร้อมบุตรอายุต่ำกว่า 16 ปี 1-2คน</div>
        <div class="sub-content">บิดา และมารดา ทำพร้อมบุตรอายุเกิน 16ปี</div>
        <div class="sub-content">
          บิดาหรือมารดา และบุตรอายุเกิน16 ปี ทำพร้อมบุตรอายุต่ำกว่า 16ปี 1-2คน
        </div>
      </div>
      <div class="deductible-discount-table-container">
        <div class="header-table">อายุ</div>
        <div class="header-table">DD 5,000</div>
        <div class="header-table">DD 10,000</div>
        <div class="header-table">DD 15,000</div>
        <div class="content-table">1 เดือน - 15 ปี</div>
        <div class="content-table">3,000</div>
        <div class="content-table">6,000</div>
        <div class="content-table">8,400</div>
        <div class="content-table">16 - 50 ปี</div>
        <div class="content-table">840</div>
        <div class="content-table">1,590</div>
        <div class="content-table">2,230</div>
        <div class="content-table">51 - 70 ปี</div>
        <div class="content-table">1,600</div>
        <div class="content-table">3,040</div>
        <div class="content-table">4,260</div>
      </div>
    </div>

    <Panel class="deductible-information-container" title="ส่วนลด Deductible (DD)">
      <div class="deductible-description">
        1. ส่วนลดเบี้ยประกันภัยสำหรับการติดเงื่อนไขความรับผิดส่วนแรก (Deductible-DD) สำหรับค่าห้อง
        และค่ารักษาพยาบาลผู้ป่วยใน
      </div>
      <div class="form-group">
        <div class="input-group">
          <div
            class="deductible-radio-container"
            v-for="deductInfo in deductibleInformationData"
            v-if="!(!isFamilyType && deductInfo.id === 'DDC00' && insuredAge < 16)"
            :key="deductInfo.id"
          >
            <Radio
              name="deductible"
              :label="deductInfo.id"
              v-model="insurancePlan.deductible"
              :disabled="disabledForm"
            >
              <span v-if="!deductInfo.deduct">ไม่จ่ายค่าเสียหายส่วนแรก</span>
              <span v-if="deductInfo.deduct">DD {{ deductInfo.deduct | formatNumber }} </span>
              <span v-if="deductInfo.deduct">({{ deductInfo.discount | formatNumber }} บาท) </span>
            </Radio>
          </div>
        </div>
      </div>
    </Panel>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'

import Checkbox from '@/components/Checkbox'
import Panel from '@/components/Panel'
import Radio from '@/components/Radio'

export default {
  name: 'InsuranceTablePlan',
  props: {
    isFamilyType: {
      type: Boolean,
      default: false,
    },
    insurancePlan: Object,
    disabledForm: Boolean,
    isShowExtra: {
      type: Boolean,
      default: true,
    },
    insuredAge: [String, Number],
  },
  components: {
    Checkbox,
    Panel,
    Radio,
  },
  computed: {
    ...mapGetters(['insurancePlanInformationData', 'deductibleInformationData']),
  },
  methods: {
    checkIsMainContent(sumInsured) {
      const convertToArr = _.values(sumInsured)

      const isHasEmpty = _.includes(convertToArr, '')
      const isHasNull = _.includes(convertToArr, null)

      return isHasEmpty || isHasNull
    },
    onCheckInsurancePlan($evt, key) {
      this.insurancePlan[key] = $evt.target.checked
    },
  },
}
</script>

<style lang="scss">
$ipd: #00a350;
$opd: #4b775c;
$hib: #3f74b0;
$cancer: #727072;
$ci: #cbab42;

.insurance-table-plan-container {
  font-size: 14px;
  line-height: 18px;

  .insurance-table-plan-header-section {
    color: #000;
    font-size: 18px;
    line-height: 22px;
    text-align: center;

    .insurance-table-plan-header {
      margin-bottom: 12px;
    }
  }

  .total-plan-section {
    margin-bottom: 4px;

    .total-plan-header {
      background-color: #c4c4c4;
      color: #000;
      margin-bottom: 4px;
      padding: 12px;
      text-align: center;
    }

    .total-plan-amount-section {
      display: grid;
      grid-template-columns: 1fr;
      grid-gap: 4px;

      &.with-extra {
        grid-template-columns: 1fr 1fr;

        .total-plan-amount:last-child {
          display: flex;
        }
      }

      .total-plan-amount {
        align-items: center;
        background-color: #3e88b9;
        color: #fff;
        display: flex;
        flex-flow: column;
        justify-content: center;
        padding: 16px;

        .plan-name {
          font-family: 'psl_kanda_extraregular';
          margin-bottom: 8px;
        }

        .plan-description {
          margin-bottom: 8px;
        }

        .plan-amount {
          font-family: 'psl_kanda_extraregular';
          font-size: 22px;
          line-height: 26px;
          margin-bottom: 16px;
        }

        &:last-child {
          display: none;
        }
      }
    }
  }

  .protection-benefit-section {
    margin-bottom: 16px;

    .protection-benefit-header {
      background-color: #c4c4c4;
      color: #000;
      margin-bottom: 4px;
      padding: 12px;
      text-align: center;
    }

    .protection-information-section {
      .radio-package-plan-container {
        display: grid;
        grid-template-columns: 1fr;
        grid-gap: 4px;
        margin-bottom: 4px;

        &.with-extra {
          grid-template-columns: 1fr 1fr;

          .radio-package-plan:last-child {
            display: flex;
          }
        }

        .radio-package-plan {
          align-items: center;
          background-color: $ipd;
          display: flex;
          justify-content: center;
          padding: 12px;

          .radio {
            margin-bottom: 12px;
          }

          &:last-child {
            display: none;
          }
        }
      }

      .ipd-protection-benefit-section,
      .opd-protection-benefit-section,
      .hib-protection-benefit-section,
      .cancer-protection-benefit-section,
      .ci-protection-benefit-section {
        margin-bottom: 4px;
      }

      .ipd-protection-benefit-section {
        .benefit-header-section {
          .package-name,
          .package-description {
            background-color: $ipd;
          }
        }

        .benefit-body-section {
          counter-reset: benefit-counter;

          .content-section {
            &:not(:first-child) {
              &:not(.main-content) {
                .benefit-description::before {
                  content: '- ';
                }
              }
            }

            &.main-content {
              .benefit-description::before {
                content: counter(benefit-counter) '. ';
                counter-increment: benefit-counter;
              }
            }
          }
        }
      }

      .opd-protection-benefit-section {
        .benefit-header-section {
          .package-name,
          .package-description {
            background-color: $opd;
          }
        }

        .benefit-body-section {
          .content-section {
            .benefit-description {
              padding: 3.5px 12px;
            }
          }
        }
      }

      .hib-protection-benefit-section {
        .benefit-header-section {
          .package-name,
          .package-description {
            background-color: $hib;
          }
        }
      }

      .cancer-protection-benefit-section {
        .benefit-header-section {
          .package-name,
          .package-description {
            background-color: $cancer;
          }
        }
      }

      .ci-protection-benefit-section {
        .benefit-header-section {
          .package-name,
          .package-description {
            background-color: $ci;
          }
        }
      }

      .benefit-header-section {
        .package-name {
          color: #fff;
          margin-bottom: 4px;
          padding: 12px;
          text-align: center;

          .check {
            display: inline-block;

            .checkmark::after {
              border-color: #fff;
            }
          }
        }

        .package-description {
          color: #fff;
          margin-bottom: 4px;
          padding: 12px;
          text-align: center;
        }
      }

      .benefit-body-section {
        .content-section {
          background-color: #fff;
          border-bottom: 1px solid #dddddd;

          &.main-content {
            background-color: #dddddd;
          }

          .benefit-description {
            padding: 12px;
            white-space: pre-line;
          }

          .benefit-value-section {
            display: grid;
            grid-template-columns: 1fr;
            grid-gap: 4px;

            &.with-extra {
              grid-template-columns: 1fr 1fr;

              .benefit-value:last-child {
                display: flex;
              }
            }

            .benefit-value {
              align-items: center;
              background-color: #c4c4c4;
              display: flex;
              justify-content: center;
              padding: 12px;

              &:last-child {
                display: none;
              }
            }
          }
        }
      }
    }
  }

  .discount-information-container {
    background-color: #fff;
    font-size: 14px;
    line-height: 24px;
    margin-bottom: 16px;
    padding: 16px 24px;

    .protection-rules,
    .family-discount-rules {
      margin-bottom: 16px;
    }

    .information-header {
      font-family: 'psl_kanda_extraregular';
    }

    .sub-content::before {
      content: '- ';
    }

    .deductible-discount-table-container {
      background-color: #bdbdbd;
      border: 1px solid #fff;
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      grid-template-rows: repeat(4, 40px);
      grid-gap: 1px;
      padding: 1px;

      .header-table,
      .content-table {
        align-items: center;
        background-color: #fff;
        display: flex;
        justify-content: center;
      }

      .header-table {
        font-family: 'psl_kanda_extraregular';
      }
    }
  }

  .deductible-information-container {
    .deductible-description {
      margin-bottom: 16px;
    }

    .deductible-radio-container {
      margin-bottom: 24px;
      width: 50%;
      float: left;
    }
  }
}

$opd: #4b775c;
$hib: #3f74b0;
$cancer: #727072;
$ci: #cbab42;
</style>
